export const DEFAULT_CATEGORY_OPTIONS = [
  { value: 'Geografi', label: 'Geografi' },
  { value: 'Historia', label: 'Historia' },
  { value: 'Naturvetenskap', label: 'Naturvetenskap' },
  { value: 'Kultur', label: 'Kultur' },
  { value: 'Sport', label: 'Sport' },
  { value: 'Natur', label: 'Natur' },
  { value: 'Teknik', label: 'Teknik' },
  { value: 'Djur', label: 'Djur' },
  { value: 'Gåtor', label: 'Gåtor' }
];
